import P, { useContext as X, useState as G, useRef as S, forwardRef as Ge, createContext as $e, useCallback as C, useEffect as I, useMemo as ie } from "react";
import { c as gt } from "./clsx-OuTLNxxd.js";
import "./index-DWGznc13.js";
const ce = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, je = /* @__PURE__ */ P.createContext(ce), $t = /* @__PURE__ */ P.createContext(!1);
let vt = !!(typeof window < "u" && window.document && window.document.createElement), ye = /* @__PURE__ */ new WeakMap();
function yt(e = !1) {
  let t = X(je), n = S(null);
  if (n.current === null && !e) {
    var r, i;
    let s = (i = P.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || i === void 0 || (r = i.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (s) {
      let a = ye.get(s);
      a == null ? ye.set(s, {
        id: t.current,
        state: s.memoizedState
      }) : s.memoizedState !== a.state && (t.current = a.id, ye.delete(s));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function ht(e) {
  let t = X(je);
  t === ce && !vt && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = yt(!!e), r = t === ce && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function mt(e) {
  let t = P.useId(), [n] = G(Xe()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${ce.prefix}`;
  return e || `${r}-${t}`;
}
const Pt = typeof P.useId == "function" ? mt : ht;
function Tt() {
  return !1;
}
function Et() {
  return !0;
}
function wt(e) {
  return () => {
  };
}
function Xe() {
  return typeof P.useSyncExternalStore == "function" ? P.useSyncExternalStore(wt, Tt, Et) : X($t);
}
if (typeof HTMLTemplateElement < "u") {
  const e = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : e.call(this);
    }
  });
}
const xt = /* @__PURE__ */ $e(!1);
typeof DocumentFragment < "u" && new DocumentFragment();
function Ye(e) {
  let t = (n, r) => X(xt) ? null : e(n, r);
  return t.displayName = e.displayName || e.name, Ge(t);
}
const Z = typeof document < "u" ? P.useLayoutEffect : () => {
};
function B(e) {
  const t = S(null);
  return Z(() => {
    t.current = e;
  }, [
    e
  ]), C((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
function St(e) {
  let [t, n] = G(e), r = S(null), i = B(() => {
    if (!r.current) return;
    let a = r.current.next();
    if (a.done) {
      r.current = null;
      return;
    }
    t === a.value ? i() : n(a.value);
  });
  Z(() => {
    r.current && i();
  });
  let s = B((a) => {
    r.current = a(t), i();
  });
  return [
    t,
    s
  ];
}
let Lt = !!(typeof window < "u" && window.document && window.document.createElement), _ = /* @__PURE__ */ new Map();
function Te(e) {
  let [t, n] = G(e), r = S(null), i = Pt(t), s = C((a) => {
    r.current = a;
  }, []);
  return Lt && (_.has(i) && !_.get(i).includes(s) ? _.set(i, [
    ..._.get(i),
    s
  ]) : _.set(i, [
    s
  ])), Z(() => {
    let a = i;
    return () => {
      _.delete(a);
    };
  }, [
    i
  ]), I(() => {
    let a = r.current;
    a && (r.current = null, n(a));
  }), i;
}
function Ct(e, t) {
  if (e === t) return e;
  let n = _.get(e);
  if (n)
    return n.forEach((i) => i(t)), t;
  let r = _.get(t);
  return r ? (r.forEach((i) => i(e)), e) : t;
}
function Hn(e = []) {
  let t = Te(), [n, r] = St(t), i = C(() => {
    r(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    r
  ]);
  return Z(i, [
    t,
    i,
    ...e
  ]), n;
}
function Re(...e) {
  return (...t) => {
    for (let n of e) typeof n == "function" && n(...t);
  };
}
const L = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, D = (e) => e && "window" in e && e.window === e ? e : L(e).defaultView || window;
function O(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let i in r) {
      let s = t[i], a = r[i];
      typeof s == "function" && typeof a == "function" && // This is a lot faster than a regex.
      i[0] === "o" && i[1] === "n" && i.charCodeAt(2) >= /* 'A' */
      65 && i.charCodeAt(2) <= /* 'Z' */
      90 ? t[i] = Re(s, a) : (i === "className" || i === "UNSAFE_className") && typeof s == "string" && typeof a == "string" ? t[i] = gt(s, a) : i === "id" && s && a ? t.id = Ct(s, a) : t[i] = a !== void 0 ? a : s;
    }
  }
  return t;
}
function Ft(...e) {
  return e.length === 1 && e[0] ? e[0] : (t) => {
    for (let n of e)
      typeof n == "function" ? n(t) : n != null && (n.current = t);
  };
}
const Mt = /* @__PURE__ */ new Set([
  "id"
]), kt = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), Kt = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), Ht = /^(data-.*)$/;
function Ce(e, t = {}) {
  let { labelable: n, isLink: r, propNames: i } = t, s = {};
  for (const a in e) Object.prototype.hasOwnProperty.call(e, a) && (Mt.has(a) || n && kt.has(a) || r && Kt.has(a) || i != null && i.has(a) || Ht.test(a)) && (s[a] = e[a]);
  return s;
}
function R(e) {
  if (Dt()) e.focus({
    preventScroll: !0
  });
  else {
    let t = It(e);
    e.focus(), Ot(t);
  }
}
let ae = null;
function Dt() {
  if (ae == null) {
    ae = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return ae = !0, !0;
        }
      });
    } catch {
    }
  }
  return ae;
}
function It(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function Ot(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
function ve(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function Fe(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function Y(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
const te = Y(function() {
  return Fe(/^Mac/i);
}), At = Y(function() {
  return Fe(/^iPhone/i);
}), ze = Y(function() {
  return Fe(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  te() && navigator.maxTouchPoints > 1;
}), qe = Y(function() {
  return At() || ze();
}), Vt = Y(function() {
  return ve(/AppleWebKit/i) && !Nt();
}), Nt = Y(function() {
  return ve(/Chrome/i);
}), Je = Y(function() {
  return ve(/Android/i);
}), Wt = Y(function() {
  return ve(/Firefox/i);
});
function ne(e, t, n = !0) {
  var r, i;
  let { metaKey: s, ctrlKey: a, altKey: u, shiftKey: f } = t;
  Wt() && (!((i = window.event) === null || i === void 0 || (r = i.type) === null || r === void 0) && r.startsWith("key")) && e.target === "_blank" && (te() ? s = !0 : a = !0);
  let p = Vt() && te() && !ze() ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: s,
    ctrlKey: a,
    altKey: u,
    shiftKey: f
  }) : new MouseEvent("click", {
    metaKey: s,
    ctrlKey: a,
    altKey: u,
    shiftKey: f,
    bubbles: !0,
    cancelable: !0
  });
  ne.isOpening = n, R(e), e.dispatchEvent(p), ne.isOpening = !1;
}
ne.isOpening = !1;
let J = /* @__PURE__ */ new Map(), Ee = /* @__PURE__ */ new Set();
function De() {
  if (typeof window > "u") return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    if (!e(r) || !r.target) return;
    let i = J.get(r.target);
    i || (i = /* @__PURE__ */ new Set(), J.set(r.target, i), r.target.addEventListener("transitioncancel", n, {
      once: !0
    })), i.add(r.propertyName);
  }, n = (r) => {
    if (!e(r) || !r.target) return;
    let i = J.get(r.target);
    if (i && (i.delete(r.propertyName), i.size === 0 && (r.target.removeEventListener("transitioncancel", n), J.delete(r.target)), J.size === 0)) {
      for (let s of Ee) s();
      Ee.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? De() : document.addEventListener("DOMContentLoaded", De));
function Qe(e) {
  requestAnimationFrame(() => {
    J.size === 0 ? e() : Ee.add(e);
  });
}
function Ut() {
  let e = S(/* @__PURE__ */ new Map()), t = C((i, s, a, u) => {
    let f = u != null && u.once ? (...p) => {
      e.current.delete(a), a(...p);
    } : a;
    e.current.set(a, {
      type: s,
      eventTarget: i,
      fn: f,
      options: u
    }), i.addEventListener(s, a, u);
  }, []), n = C((i, s, a, u) => {
    var f;
    let p = ((f = e.current.get(a)) === null || f === void 0 ? void 0 : f.fn) || a;
    i.removeEventListener(s, p, u), e.current.delete(a);
  }, []), r = C(() => {
    e.current.forEach((i, s) => {
      n(i.eventTarget, i.type, s, i.options);
    });
  }, [
    n
  ]);
  return I(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function Me(e) {
  const t = S(null);
  return ie(() => ({
    get current() {
      return t.current;
    },
    set current(n) {
      t.current = n, typeof e == "function" ? e(n) : e && (e.current = n);
    }
  }), [
    e
  ]);
}
function ke(e, t) {
  Z(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
function we(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : Je() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function _t(e) {
  return !Je() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
const Ie = Symbol("default");
function Dn({ values: e, children: t }) {
  for (let [n, r] of e)
    t = /* @__PURE__ */ P.createElement(n.Provider, {
      value: r
    }, t);
  return t;
}
function Ze(e) {
  let { className: t, style: n, children: r, defaultClassName: i, defaultChildren: s, defaultStyle: a, values: u } = e;
  return ie(() => {
    let f, p, b;
    return typeof t == "function" ? f = t({
      ...u,
      defaultClassName: i
    }) : f = t, typeof n == "function" ? p = n({
      ...u,
      defaultStyle: a || {}
    }) : p = n, typeof r == "function" ? b = r({
      ...u,
      defaultChildren: s
    }) : r == null ? b = s : b = r, {
      className: f ?? i,
      style: p || a ? {
        ...a,
        ...p
      } : void 0,
      children: b ?? s,
      "data-rac": ""
    };
  }, [
    t,
    n,
    r,
    i,
    s,
    a,
    u
  ]);
}
function Bt(e, t) {
  let n = X(e);
  if (t === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = new Intl.ListFormat().format(Object.keys(n.slots).map((s) => `"${s}"`));
    if (!t && !n.slots[Ie]) throw new Error(`A slot prop is required. Valid slot names are ${r}.`);
    let i = t || Ie;
    if (!n.slots[i])
      throw new Error(`Invalid slot "${t}". Valid slot names are ${r}.`);
    return n.slots[i];
  }
  return n;
}
function et(e, t, n) {
  let r = Bt(n, e.slot) || {}, { ref: i, ...s } = r, a = Me(ie(() => Ft(t, i), [
    t,
    i
  ])), u = O(s, e);
  return "style" in s && s.style && "style" in e && e.style && (typeof s.style == "function" || typeof e.style == "function" ? u.style = (f) => {
    let p = typeof s.style == "function" ? s.style(f) : s.style, b = {
      ...f.defaultStyle,
      ...p
    }, y = typeof e.style == "function" ? e.style({
      ...f,
      defaultStyle: b
    }) : e.style;
    return {
      ...b,
      ...y
    };
  } : u.style = {
    ...s.style,
    ...e.style
  }), [
    u,
    a
  ];
}
let Q = "default", xe = "", de = /* @__PURE__ */ new WeakMap();
function Oe(e) {
  if (qe()) {
    if (Q === "default") {
      const t = L(e);
      xe = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    Q = "disabled";
  } else (e instanceof HTMLElement || e instanceof SVGElement) && (de.set(e, e.style.userSelect), e.style.userSelect = "none");
}
function se(e) {
  if (qe()) {
    if (Q !== "disabled") return;
    Q = "restoring", setTimeout(() => {
      Qe(() => {
        if (Q === "restoring") {
          const t = L(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = xe || ""), xe = "", Q = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && de.has(e)) {
    let t = de.get(e);
    e.style.userSelect === "none" && (e.style.userSelect = t), e.getAttribute("style") === "" && e.removeAttribute("style"), de.delete(e);
  }
}
const fe = P.createContext({
  register: () => {
  }
});
fe.displayName = "PressResponderContext";
function Gt(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function tt(e, t, n) {
  if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
  return t.get(e);
}
function jt(e, t) {
  var n = tt(e, t, "get");
  return Gt(e, n);
}
function Xt(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Yt(e, t, n) {
  Xt(e, t), t.set(e, n);
}
function Rt(e, t, n) {
  if (t.set) t.set.call(e, n);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = n;
  }
}
function Ae(e, t, n) {
  var r = tt(e, t, "set");
  return Rt(e, r, n), n;
}
function zt(e) {
  let t = X(fe);
  if (t) {
    let { register: n, ...r } = t;
    e = O(r, e), n();
  }
  return ke(t, e.ref), e;
}
var le = /* @__PURE__ */ new WeakMap();
class ue {
  continuePropagation() {
    Ae(this, le, !1);
  }
  get shouldStopPropagation() {
    return jt(this, le);
  }
  constructor(t, n, r, i) {
    Yt(this, le, {
      writable: !0,
      value: void 0
    }), Ae(this, le, !0);
    var s;
    let a = (s = i == null ? void 0 : i.target) !== null && s !== void 0 ? s : r.currentTarget;
    const u = a == null ? void 0 : a.getBoundingClientRect();
    let f, p = 0, b, y = null;
    r.clientX != null && r.clientY != null && (b = r.clientX, y = r.clientY), u && (b != null && y != null ? (f = b - u.left, p = y - u.top) : (f = u.width / 2, p = u.height / 2)), this.type = t, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = f, this.y = p;
  }
}
const Ve = Symbol("linkClicked");
function qt(e) {
  let {
    onPress: t,
    onPressChange: n,
    onPressStart: r,
    onPressEnd: i,
    onPressUp: s,
    isDisabled: a,
    isPressed: u,
    preventFocusOnPress: f,
    shouldCancelOnPointerExit: p,
    allowTextSelectionOnPress: b,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: y,
    ...T
  } = zt(e), [g, x] = G(!1), h = S({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    ignoreClickAfterPress: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null
  }), { addGlobalListener: w, removeAllGlobalListeners: M } = Ut(), k = B((o, $) => {
    let K = h.current;
    if (a || K.didFirePressStart) return !1;
    let c = !0;
    if (K.isTriggeringEvent = !0, r) {
      let m = new ue("pressstart", $, o);
      r(m), c = m.shouldStopPropagation;
    }
    return n && n(!0), K.isTriggeringEvent = !1, K.didFirePressStart = !0, x(!0), c;
  }), E = B((o, $, K = !0) => {
    let c = h.current;
    if (!c.didFirePressStart) return !1;
    c.ignoreClickAfterPress = !0, c.didFirePressStart = !1, c.isTriggeringEvent = !0;
    let m = !0;
    if (i) {
      let l = new ue("pressend", $, o);
      i(l), m = l.shouldStopPropagation;
    }
    if (n && n(!1), x(!1), t && K && !a) {
      let l = new ue("press", $, o);
      t(l), m && (m = l.shouldStopPropagation);
    }
    return c.isTriggeringEvent = !1, m;
  }), W = B((o, $) => {
    let K = h.current;
    if (a) return !1;
    if (s) {
      K.isTriggeringEvent = !0;
      let c = new ue("pressup", $, o);
      return s(c), K.isTriggeringEvent = !1, c.shouldStopPropagation;
    }
    return !0;
  }), A = B((o) => {
    let $ = h.current;
    $.isPressed && $.target && ($.isOverTarget && $.pointerType != null && E(N($.target, o), $.pointerType, !1), $.isPressed = !1, $.isOverTarget = !1, $.activePointerId = null, $.pointerType = null, M(), b || se($.target));
  }), oe = B((o) => {
    p && A(o);
  }), bt = ie(() => {
    let o = h.current, $ = {
      onKeyDown(c) {
        if (he(c.nativeEvent, c.currentTarget) && c.currentTarget.contains(c.target)) {
          var m;
          We(c.target, c.key) && c.preventDefault();
          let l = !0;
          if (!o.isPressed && !c.repeat) {
            o.target = c.currentTarget, o.isPressed = !0, l = k(c, "keyboard");
            let v = c.currentTarget, d = (V) => {
              he(V, v) && !V.repeat && v.contains(V.target) && o.target && W(N(o.target, V), "keyboard");
            };
            w(L(c.currentTarget), "keyup", Re(d, K), !0);
          }
          l && c.stopPropagation(), c.metaKey && te() && ((m = o.metaKeyEvents) === null || m === void 0 || m.set(c.key, c.nativeEvent));
        } else c.key === "Meta" && (o.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(c) {
        if (!(c && !c.currentTarget.contains(c.target)) && c && c.button === 0 && !o.isTriggeringEvent && !ne.isOpening) {
          let m = !0;
          if (a && c.preventDefault(), !o.ignoreClickAfterPress && !o.ignoreEmulatedMouseEvents && !o.isPressed && (o.pointerType === "virtual" || we(c.nativeEvent))) {
            !a && !f && R(c.currentTarget);
            let l = k(c, "virtual"), v = W(c, "virtual"), d = E(c, "virtual");
            m = l && v && d;
          }
          o.ignoreEmulatedMouseEvents = !1, o.ignoreClickAfterPress = !1, m && c.stopPropagation();
        }
      }
    }, K = (c) => {
      var m;
      if (o.isPressed && o.target && he(c, o.target)) {
        var l;
        We(c.target, c.key) && c.preventDefault();
        let d = c.target;
        E(N(o.target, c), "keyboard", o.target.contains(d)), M(), c.key !== "Enter" && Ke(o.target) && o.target.contains(d) && !c[Ve] && (c[Ve] = !0, ne(o.target, c, !1)), o.isPressed = !1, (l = o.metaKeyEvents) === null || l === void 0 || l.delete(c.key);
      } else if (c.key === "Meta" && (!((m = o.metaKeyEvents) === null || m === void 0) && m.size)) {
        var v;
        let d = o.metaKeyEvents;
        o.metaKeyEvents = void 0;
        for (let V of d.values()) (v = o.target) === null || v === void 0 || v.dispatchEvent(new KeyboardEvent("keyup", V));
      }
    };
    if (typeof PointerEvent < "u") {
      $.onPointerDown = (d) => {
        if (d.button !== 0 || !d.currentTarget.contains(d.target)) return;
        if (_t(d.nativeEvent)) {
          o.pointerType = "virtual";
          return;
        }
        me(d.currentTarget) && d.preventDefault(), o.pointerType = d.pointerType;
        let V = !0;
        o.isPressed || (o.isPressed = !0, o.isOverTarget = !0, o.activePointerId = d.pointerId, o.target = d.currentTarget, !a && !f && R(d.currentTarget), b || Oe(o.target), V = k(d, o.pointerType), w(L(d.currentTarget), "pointermove", c, !1), w(L(d.currentTarget), "pointerup", m, !1), w(L(d.currentTarget), "pointercancel", v, !1)), V && d.stopPropagation();
      }, $.onMouseDown = (d) => {
        d.currentTarget.contains(d.target) && d.button === 0 && (me(d.currentTarget) && d.preventDefault(), d.stopPropagation());
      }, $.onPointerUp = (d) => {
        !d.currentTarget.contains(d.target) || o.pointerType === "virtual" || d.button === 0 && q(d, d.currentTarget) && W(d, o.pointerType || d.pointerType);
      };
      let c = (d) => {
        d.pointerId === o.activePointerId && (o.target && q(d, o.target) ? !o.isOverTarget && o.pointerType != null && (o.isOverTarget = !0, k(N(o.target, d), o.pointerType)) : o.target && o.isOverTarget && o.pointerType != null && (o.isOverTarget = !1, E(N(o.target, d), o.pointerType, !1), oe(d)));
      }, m = (d) => {
        d.pointerId === o.activePointerId && o.isPressed && d.button === 0 && o.target && (q(d, o.target) && o.pointerType != null ? E(N(o.target, d), o.pointerType) : o.isOverTarget && o.pointerType != null && E(N(o.target, d), o.pointerType, !1), o.isPressed = !1, o.isOverTarget = !1, o.activePointerId = null, o.pointerType = null, M(), b || se(o.target), "ontouchend" in o.target && d.pointerType !== "mouse" && w(o.target, "touchend", l, {
          once: !0
        }));
      }, l = (d) => {
        nt(d.currentTarget) && d.preventDefault();
      }, v = (d) => {
        A(d);
      };
      $.onDragStart = (d) => {
        d.currentTarget.contains(d.target) && A(d);
      };
    } else {
      $.onMouseDown = (l) => {
        if (l.button !== 0 || !l.currentTarget.contains(l.target)) return;
        if (me(l.currentTarget) && l.preventDefault(), o.ignoreEmulatedMouseEvents) {
          l.stopPropagation();
          return;
        }
        o.isPressed = !0, o.isOverTarget = !0, o.target = l.currentTarget, o.pointerType = we(l.nativeEvent) ? "virtual" : "mouse", !a && !f && R(l.currentTarget), k(l, o.pointerType) && l.stopPropagation(), w(L(l.currentTarget), "mouseup", c, !1);
      }, $.onMouseEnter = (l) => {
        if (!l.currentTarget.contains(l.target)) return;
        let v = !0;
        o.isPressed && !o.ignoreEmulatedMouseEvents && o.pointerType != null && (o.isOverTarget = !0, v = k(l, o.pointerType)), v && l.stopPropagation();
      }, $.onMouseLeave = (l) => {
        if (!l.currentTarget.contains(l.target)) return;
        let v = !0;
        o.isPressed && !o.ignoreEmulatedMouseEvents && o.pointerType != null && (o.isOverTarget = !1, v = E(l, o.pointerType, !1), oe(l)), v && l.stopPropagation();
      }, $.onMouseUp = (l) => {
        l.currentTarget.contains(l.target) && !o.ignoreEmulatedMouseEvents && l.button === 0 && W(l, o.pointerType || "mouse");
      };
      let c = (l) => {
        if (l.button === 0) {
          if (o.isPressed = !1, M(), o.ignoreEmulatedMouseEvents) {
            o.ignoreEmulatedMouseEvents = !1;
            return;
          }
          o.target && q(l, o.target) && o.pointerType != null ? E(N(o.target, l), o.pointerType) : o.target && o.isOverTarget && o.pointerType != null && E(N(o.target, l), o.pointerType, !1), o.isOverTarget = !1;
        }
      };
      $.onTouchStart = (l) => {
        if (!l.currentTarget.contains(l.target)) return;
        let v = Jt(l.nativeEvent);
        if (!v) return;
        o.activePointerId = v.identifier, o.ignoreEmulatedMouseEvents = !0, o.isOverTarget = !0, o.isPressed = !0, o.target = l.currentTarget, o.pointerType = "touch", !a && !f && R(l.currentTarget), b || Oe(o.target), k(U(o.target, l), o.pointerType) && l.stopPropagation(), w(D(l.currentTarget), "scroll", m, !0);
      }, $.onTouchMove = (l) => {
        if (!l.currentTarget.contains(l.target)) return;
        if (!o.isPressed) {
          l.stopPropagation();
          return;
        }
        let v = Ne(l.nativeEvent, o.activePointerId), d = !0;
        v && q(v, l.currentTarget) ? !o.isOverTarget && o.pointerType != null && (o.isOverTarget = !0, d = k(U(o.target, l), o.pointerType)) : o.isOverTarget && o.pointerType != null && (o.isOverTarget = !1, d = E(U(o.target, l), o.pointerType, !1), oe(U(o.target, l))), d && l.stopPropagation();
      }, $.onTouchEnd = (l) => {
        if (!l.currentTarget.contains(l.target)) return;
        if (!o.isPressed) {
          l.stopPropagation();
          return;
        }
        let v = Ne(l.nativeEvent, o.activePointerId), d = !0;
        v && q(v, l.currentTarget) && o.pointerType != null ? (W(U(o.target, l), o.pointerType), d = E(U(o.target, l), o.pointerType)) : o.isOverTarget && o.pointerType != null && (d = E(U(o.target, l), o.pointerType, !1)), d && l.stopPropagation(), o.isPressed = !1, o.activePointerId = null, o.isOverTarget = !1, o.ignoreEmulatedMouseEvents = !0, o.target && !b && se(o.target), M();
      }, $.onTouchCancel = (l) => {
        l.currentTarget.contains(l.target) && (l.stopPropagation(), o.isPressed && A(U(o.target, l)));
      };
      let m = (l) => {
        o.isPressed && l.target.contains(o.target) && A({
          currentTarget: o.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      $.onDragStart = (l) => {
        l.currentTarget.contains(l.target) && A(l);
      };
    }
    return $;
  }, [
    w,
    a,
    f,
    M,
    b,
    A,
    oe,
    E,
    k,
    W
  ]);
  return I(() => () => {
    var o;
    b || se((o = h.current.target) !== null && o !== void 0 ? o : void 0);
  }, [
    b
  ]), {
    isPressed: u || g,
    pressProps: O(T, bt)
  };
}
function Ke(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function he(e, t) {
  const { key: n, code: r } = e, i = t, s = i.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(i instanceof D(i).HTMLInputElement && !rt(i, n) || i instanceof D(i).HTMLTextAreaElement || i.isContentEditable) && // Links should only trigger with Enter key
  !((s === "link" || !s && Ke(i)) && n !== "Enter");
}
function Jt(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function Ne(e, t) {
  const n = e.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const i = n[r];
    if (i.identifier === t) return i;
  }
  return null;
}
function U(e, t) {
  let n = 0, r = 0;
  return t.targetTouches && t.targetTouches.length === 1 && (n = t.targetTouches[0].clientX, r = t.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function N(e, t) {
  let n = t.clientX, r = t.clientY;
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function Qt(e) {
  let t = 0, n = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? n = e.height / 2 : e.radiusY !== void 0 && (n = e.radiusY), {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function Zt(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function q(e, t) {
  let n = t.getBoundingClientRect(), r = Qt(e);
  return Zt(n, r);
}
function me(e) {
  return !(e instanceof HTMLElement) || !e.hasAttribute("draggable");
}
function nt(e) {
  return e instanceof HTMLInputElement ? !1 : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !Ke(e);
}
function We(e, t) {
  return e instanceof HTMLInputElement ? !rt(e, t) : nt(e);
}
const en = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function rt(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : en.has(e.type);
}
const tn = /* @__PURE__ */ P.forwardRef(({ children: e, ...t }, n) => {
  let r = S(!1), i = X(fe);
  n = Me(n || (i == null ? void 0 : i.ref));
  let s = O(i || {}, {
    ...t,
    ref: n,
    register() {
      r.current = !0, i && i.register();
    }
  });
  return ke(i, n), I(() => {
    r.current || (console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component."), r.current = !0);
  }, []), /* @__PURE__ */ P.createElement(fe.Provider, {
    value: s
  }, e);
});
class nn {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, n) {
    this.nativeEvent = n, this.target = n.target, this.currentTarget = n.currentTarget, this.relatedTarget = n.relatedTarget, this.bubbles = n.bubbles, this.cancelable = n.cancelable, this.defaultPrevented = n.defaultPrevented, this.eventPhase = n.eventPhase, this.isTrusted = n.isTrusted, this.timeStamp = n.timeStamp, this.type = t;
  }
}
function it(e) {
  let t = S({
    isFocused: !1,
    observer: null
  });
  Z(() => {
    const r = t.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = B((r) => {
    e == null || e(r);
  });
  return C((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let i = r.target, s = (a) => {
        t.current.isFocused = !1, i.disabled && n(new nn("blur", a)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      i.addEventListener("focusout", s, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && i.disabled) {
          var a;
          (a = t.current.observer) === null || a === void 0 || a.disconnect();
          let u = i === document.activeElement ? null : document.activeElement;
          i.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: u
          })), i.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: u
          }));
        }
      }), t.current.observer.observe(i, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
function ot(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: i } = e;
  const s = C((f) => {
    if (f.target === f.currentTarget)
      return r && r(f), i && i(!1), !0;
  }, [
    r,
    i
  ]), a = it(s), u = C((f) => {
    const p = L(f.target);
    f.target === f.currentTarget && p.activeElement === f.target && (n && n(f), i && i(!0), a(f));
  }, [
    i,
    n,
    a
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || i || r) ? u : void 0,
      onBlur: !t && (r || i) ? s : void 0
    }
  };
}
let j = null, re = /* @__PURE__ */ new Set(), ee = /* @__PURE__ */ new Map(), z = !1, Se = !1;
const rn = {
  Tab: !0,
  Escape: !0
};
function He(e, t) {
  for (let n of re) n(e, t);
}
function on(e) {
  return !(e.metaKey || !te() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function pe(e) {
  z = !0, on(e) && (j = "keyboard", He("keyboard", e));
}
function F(e) {
  j = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (z = !0, He("pointer", e));
}
function at(e) {
  we(e) && (z = !0, j = "virtual");
}
function st(e) {
  e.target === window || e.target === document || (!z && !Se && (j = "virtual", He("virtual", e)), z = !1, Se = !1);
}
function lt() {
  z = !1, Se = !0;
}
function be(e) {
  if (typeof window > "u" || ee.get(D(e))) return;
  const t = D(e), n = L(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    z = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", pe, !0), n.addEventListener("keyup", pe, !0), n.addEventListener("click", at, !0), t.addEventListener("focus", st, !0), t.addEventListener("blur", lt, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", F, !0), n.addEventListener("pointermove", F, !0), n.addEventListener("pointerup", F, !0)) : (n.addEventListener("mousedown", F, !0), n.addEventListener("mousemove", F, !0), n.addEventListener("mouseup", F, !0)), t.addEventListener("beforeunload", () => {
    ut(e);
  }, {
    once: !0
  }), ee.set(t, {
    focus: r
  });
}
const ut = (e, t) => {
  const n = D(e), r = L(e);
  t && r.removeEventListener("DOMContentLoaded", t), ee.has(n) && (n.HTMLElement.prototype.focus = ee.get(n).focus, r.removeEventListener("keydown", pe, !0), r.removeEventListener("keyup", pe, !0), r.removeEventListener("click", at, !0), n.removeEventListener("focus", st, !0), n.removeEventListener("blur", lt, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", F, !0), r.removeEventListener("pointermove", F, !0), r.removeEventListener("pointerup", F, !0)) : (r.removeEventListener("mousedown", F, !0), r.removeEventListener("mousemove", F, !0), r.removeEventListener("mouseup", F, !0)), ee.delete(n));
};
function an(e) {
  const t = L(e);
  let n;
  return t.readyState !== "loading" ? be(e) : (n = () => {
    be(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => ut(e, n);
}
typeof document < "u" && an();
function dt() {
  return j !== "pointer";
}
function sn() {
  return j;
}
function In() {
  be();
  let [e, t] = G(j);
  return I(() => {
    let n = () => {
      t(j);
    };
    return re.add(n), () => {
      re.delete(n);
    };
  }, []), Xe() ? null : e;
}
const ln = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function un(e, t, n) {
  var r;
  const i = typeof window < "u" ? D(n == null ? void 0 : n.target).HTMLInputElement : HTMLInputElement, s = typeof window < "u" ? D(n == null ? void 0 : n.target).HTMLTextAreaElement : HTMLTextAreaElement, a = typeof window < "u" ? D(n == null ? void 0 : n.target).HTMLElement : HTMLElement, u = typeof window < "u" ? D(n == null ? void 0 : n.target).KeyboardEvent : KeyboardEvent;
  return e = e || (n == null ? void 0 : n.target) instanceof i && !ln.has(n == null || (r = n.target) === null || r === void 0 ? void 0 : r.type) || (n == null ? void 0 : n.target) instanceof s || (n == null ? void 0 : n.target) instanceof a && (n == null ? void 0 : n.target.isContentEditable), !(e && t === "keyboard" && n instanceof u && !rn[n.key]);
}
function dn(e, t, n) {
  be(), I(() => {
    let r = (i, s) => {
      un(!!(n != null && n.isTextInput), i, s) && e(dt());
    };
    return re.add(r), () => {
      re.delete(r);
    };
  }, t);
}
function cn(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: i } = e, s = S({
    isFocusWithin: !1
  }), a = C((p) => {
    s.current.isFocusWithin && !p.currentTarget.contains(p.relatedTarget) && (s.current.isFocusWithin = !1, n && n(p), i && i(!1));
  }, [
    n,
    i,
    s
  ]), u = it(a), f = C((p) => {
    !s.current.isFocusWithin && document.activeElement === p.target && (r && r(p), i && i(!0), s.current.isFocusWithin = !0, u(p));
  }, [
    r,
    i,
    u
  ]);
  return t ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: f,
      onBlur: a
    }
  };
}
let ge = !1, Pe = 0;
function Le() {
  ge = !0, setTimeout(() => {
    ge = !1;
  }, 50);
}
function Ue(e) {
  e.pointerType === "touch" && Le();
}
function fn() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", Ue) : document.addEventListener("touchend", Le), Pe++, () => {
      Pe--, !(Pe > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", Ue) : document.removeEventListener("touchend", Le));
    };
}
function ct(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: i } = e, [s, a] = G(!1), u = S({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  I(fn, []);
  let { hoverProps: f, triggerHoverEnd: p } = ie(() => {
    let b = (g, x) => {
      if (u.pointerType = x, i || x === "touch" || u.isHovered || !g.currentTarget.contains(g.target)) return;
      u.isHovered = !0;
      let h = g.currentTarget;
      u.target = h, t && t({
        type: "hoverstart",
        target: h,
        pointerType: x
      }), n && n(!0), a(!0);
    }, y = (g, x) => {
      if (u.pointerType = "", u.target = null, x === "touch" || !u.isHovered) return;
      u.isHovered = !1;
      let h = g.currentTarget;
      r && r({
        type: "hoverend",
        target: h,
        pointerType: x
      }), n && n(!1), a(!1);
    }, T = {};
    return typeof PointerEvent < "u" ? (T.onPointerEnter = (g) => {
      ge && g.pointerType === "mouse" || b(g, g.pointerType);
    }, T.onPointerLeave = (g) => {
      !i && g.currentTarget.contains(g.target) && y(g, g.pointerType);
    }) : (T.onTouchStart = () => {
      u.ignoreEmulatedMouseEvents = !0;
    }, T.onMouseEnter = (g) => {
      !u.ignoreEmulatedMouseEvents && !ge && b(g, "mouse"), u.ignoreEmulatedMouseEvents = !1;
    }, T.onMouseLeave = (g) => {
      !i && g.currentTarget.contains(g.target) && y(g, "mouse");
    }), {
      hoverProps: T,
      triggerHoverEnd: y
    };
  }, [
    t,
    n,
    r,
    i,
    u
  ]);
  return I(() => {
    i && p({
      currentTarget: u.target
    }, u.pointerType);
  }, [
    i
  ]), {
    hoverProps: f,
    isHovered: s
  };
}
function _e(e) {
  if (!e) return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
      },
      continuePropagation() {
        t = !1;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function pn(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: _e(e.onKeyDown),
      onKeyUp: _e(e.onKeyUp)
    }
  };
}
function bn(e) {
  const t = L(e);
  if (sn() === "virtual") {
    let n = t.activeElement;
    Qe(() => {
      t.activeElement === n && e.isConnected && R(e);
    });
  } else R(e);
}
function ft(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, i = S({
    isFocused: !1,
    isFocusVisible: t || dt()
  }), [s, a] = G(!1), [u, f] = G(() => i.current.isFocused && i.current.isFocusVisible), p = C(() => f(i.current.isFocused && i.current.isFocusVisible), []), b = C((g) => {
    i.current.isFocused = g, a(g), p();
  }, [
    p
  ]);
  dn((g) => {
    i.current.isFocusVisible = g, p();
  }, [], {
    isTextInput: n
  });
  let { focusProps: y } = ot({
    isDisabled: r,
    onFocusChange: b
  }), { focusWithinProps: T } = cn({
    isDisabled: !r,
    onFocusWithinChange: b
  });
  return {
    isFocused: s,
    isFocusVisible: u,
    focusProps: r ? T : y
  };
}
let gn = /* @__PURE__ */ P.createContext(null);
function $n(e) {
  let t = X(gn) || {};
  ke(t, e);
  let { ref: n, ...r } = t;
  return r;
}
function vn(e, t) {
  let { focusProps: n } = ot(e), { keyboardProps: r } = pn(e), i = O(n, r), s = $n(t), a = e.isDisabled ? {} : s, u = S(e.autoFocus);
  return I(() => {
    u.current && t.current && bn(t.current), u.current = !1;
  }, [
    t
  ]), {
    focusableProps: O({
      ...i,
      tabIndex: e.excludeFromTabOrder && !e.isDisabled ? -1 : void 0
    }, a)
  };
}
function yn(e, t) {
  let {
    elementType: n = "button",
    isDisabled: r,
    onPress: i,
    onPressStart: s,
    onPressEnd: a,
    onPressUp: u,
    onPressChange: f,
    preventFocusOnPress: p,
    allowFocusWhenDisabled: b,
    // @ts-ignore
    onClick: y,
    href: T,
    target: g,
    rel: x,
    type: h = "button"
  } = e, w;
  n === "button" ? w = {
    type: h,
    disabled: r
  } : w = {
    role: "button",
    tabIndex: r ? void 0 : 0,
    href: n === "a" && !r ? T : void 0,
    target: n === "a" ? g : void 0,
    type: n === "input" ? h : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? x : void 0
  };
  let { pressProps: M, isPressed: k } = qt({
    onPressStart: s,
    onPressEnd: a,
    onPressChange: f,
    onPress: i,
    onPressUp: u,
    isDisabled: r,
    preventFocusOnPress: p,
    ref: t
  }), { focusableProps: E } = vn(e, t);
  b && (E.tabIndex = r ? -1 : E.tabIndex);
  let W = O(E, M, Ce(e, {
    labelable: !0
  }));
  return {
    isPressed: k,
    buttonProps: O(w, W, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      onClick: (A) => {
        y && (y(A), console.warn("onClick is deprecated, please use onPress"));
      }
    })
  };
}
const pt = 7e3;
let H = null;
function Be(e, t = "assertive", n = pt) {
  H ? H.announce(e, t, n) : (H = new hn(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? H.announce(e, t, n) : setTimeout(() => {
    H != null && H.isAttached() && (H == null || H.announce(e, t, n));
  }, 100));
}
class hn {
  isAttached() {
    var t;
    return (t = this.node) === null || t === void 0 ? void 0 : t.isConnected;
  }
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = pt) {
    var i, s;
    if (!this.node) return;
    let a = document.createElement("div");
    typeof t == "object" ? (a.setAttribute("role", "img"), a.setAttribute("aria-labelledby", t["aria-labelledby"])) : a.textContent = t, n === "assertive" ? (i = this.assertiveLog) === null || i === void 0 || i.appendChild(a) : (s = this.politeLog) === null || s === void 0 || s.appendChild(a), t !== "" && setTimeout(() => {
      a.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
const mn = /* @__PURE__ */ $e(null), Pn = /* @__PURE__ */ new Set([
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "name",
  "value"
]), Tn = /* @__PURE__ */ $e({});
function En(e, t) {
  [e, t] = et(e, t, Tn), e = wn(e);
  let n = e, { isPending: r } = n, { buttonProps: i, isPressed: s } = yn(e, t), { focusProps: a, isFocused: u, isFocusVisible: f } = ft(e), { hoverProps: p, isHovered: b } = ct({
    ...e,
    isDisabled: e.isDisabled || r
  }), y = {
    isHovered: b,
    isPressed: (n.isPressed || s) && !r,
    isFocused: u,
    isFocusVisible: f,
    isDisabled: e.isDisabled || !1,
    isPending: r ?? !1
  }, T = Ze({
    ...e,
    values: y,
    defaultClassName: "react-aria-Button"
  }), g = Te(i.id), x = Te(), h = i["aria-labelledby"];
  r && (h ? h = `${h} ${x}` : i["aria-label"] && (h = `${g} ${x}`));
  let w = S(r);
  return I(() => {
    let M = {
      "aria-labelledby": h || g
    };
    (!w.current && u && r || w.current && u && !r) && Be(M, "assertive"), w.current = r;
  }, [
    r,
    u,
    h,
    g
  ]), /* @__PURE__ */ P.createElement("button", {
    ...Ce(e, {
      propNames: Pn
    }),
    ...O(i, a, p),
    ...T,
    id: g,
    ref: t,
    "aria-labelledby": h,
    slot: e.slot || void 0,
    "aria-disabled": r ? "true" : i["aria-disabled"],
    "data-disabled": e.isDisabled || void 0,
    "data-pressed": y.isPressed || void 0,
    "data-hovered": b || void 0,
    "data-focused": u || void 0,
    "data-pending": r || void 0,
    "data-focus-visible": f || void 0
  }, /* @__PURE__ */ P.createElement(mn.Provider, {
    value: {
      id: x
    }
  }, T.children));
}
function wn(e) {
  return e.isPending && (e.onPress = void 0, e.onPressStart = void 0, e.onPressEnd = void 0, e.onPressChange = void 0, e.onPressUp = void 0, e.onKeyDown = void 0, e.onKeyUp = void 0, e.onClick = void 0, e.href = void 0), e;
}
const On = /* @__PURE__ */ Ye(En), xn = /* @__PURE__ */ $e({});
let Sn = (e) => {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, ...i } = e;
  return i;
};
function Ln(e, t) {
  [e, t] = et(e, t, xn);
  let { hoverProps: n, isHovered: r } = ct(e), { isFocused: i, isFocusVisible: s, focusProps: a } = ft({
    isTextInput: !0,
    autoFocus: e.autoFocus
  }), u = !!e["aria-invalid"] && e["aria-invalid"] !== "false", f = Ze({
    ...e,
    values: {
      isHovered: r,
      isFocused: i,
      isFocusVisible: s,
      isDisabled: e.disabled || !1,
      isInvalid: u
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ P.createElement("input", {
    ...O(Sn(e), a, n),
    ...f,
    ref: t,
    "data-focused": i || void 0,
    "data-disabled": e.disabled || void 0,
    "data-hovered": r || void 0,
    "data-focus-visible": s || void 0,
    "data-invalid": u || void 0
  });
}
const Cn = /* @__PURE__ */ Ye(Ln);
function Fn(e, t) {
  let { onSelect: n, acceptedFileTypes: r, allowsMultiple: i, defaultCamera: s, children: a, acceptDirectory: u, ...f } = e, p = Me(t), b = Ce(f);
  return /* @__PURE__ */ P.createElement(P.Fragment, null, /* @__PURE__ */ P.createElement(tn, {
    onPress: () => {
      var y, T;
      !((y = p.current) === null || y === void 0) && y.value && (p.current.value = ""), (T = p.current) === null || T === void 0 || T.click();
    }
  }, a), /* @__PURE__ */ P.createElement(Cn, {
    ...b,
    type: "file",
    ref: p,
    style: {
      display: "none"
    },
    accept: r == null ? void 0 : r.toString(),
    onChange: (y) => n == null ? void 0 : n(y.target.files),
    capture: s,
    multiple: i,
    // @ts-expect-error
    webkitdirectory: u ? "" : void 0
  }));
}
const An = /* @__PURE__ */ Ge(Fn);
export {
  An as $,
  On as a,
  Te as b,
  Z as c,
  Xe as d,
  O as e,
  cn as f,
  In as g,
  B as h,
  te as i,
  ze as j,
  ot as k,
  Re as l,
  et as m,
  Me as n,
  yn as o,
  ct as p,
  ft as q,
  Hn as r,
  Ze as s,
  Ce as t,
  Dn as u
};
